<script>
  import { onMount, getContext } from 'svelte';
  import { fade, fly } from 'svelte/transition';

  import { SEARCH_PROGRAMS } from '../../graphql/programs';

  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';

  export let label;
  export let value;

  let search = '';
  let query = client.watchQuery({
    query: SEARCH_PROGRAMS,
    variables: { limit: 1000 }
  });
  let results = { loading: true };

  function setResponse({ data, loading, error, networkStatus }) {
    results = {
      loading,
      page: data && data.programs ? data.programs.page : 1,
      total: data && data.programs ? data.programs.total : 0,
      programs: data && data.programs ? data.programs.docs : []
    };
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({ error, loading: false });
    }
  });
</script>

<div>
  <!-- LABEL-->
  {#if label}
  <label>{label}</label>
  {/if}
  <!-- LOADING -->
  {#if results.loading}
  <select class:placeholder="{true}">
    <option>Loading Programs...</option>
  </select>
  {/if}
  <!-- COMPONENT -->
  {#if !results.loading}
  <select class:placeholder="{!value}" bind:value on:change>
    <option value="{null}">Choose a Program</option>
    {#each results.programs as program, i}
    <option value="{program.id}">
      {program.name}
    </option>
    {/each}
  </select>
  {/if}
</div>
